import React from 'react';
import {Button, Icon, Tooltip, message, Modal} from 'antd';
import {
    WeaTools, WeaLocaleProvider, WeaDialog, WeaSearchGroup, WeaFormItem,
    WeaInput, WeaCheckbox, WeaBrowser, WeaInputNumber, WeaSelect, WeaUpload,
    WeaRichText, WeaFieldTemplateSelect, WeaHelpfulTip
} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;
import './style/';

const basicToolBar = {
    toolbar: [
        { name: "paragraph", items: ['JustifyLeft', 'JustifyCenter', 'JustifyRight'] },
        { name: "styles", items: ["Font", "FontSize"] },
        { name: "colors", items: ["TextColor"] }
    ]
};

class WeaSystemSetting extends React.Component {
    state = {visible: false, loading: false, data: {},
        wmSetting: {}, textVisible: false,
        textTemp: { wmwidth: '', wmheight: '', wmcontent: '' },
        imgTemp: { wmwidth: '', wmheight: ''},
        labelList: [], textEdited: false,clientTypeValue:'',optionList : []};

    constructor(props) {
        super(props);
        this.getButtons = this.getButtons.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onWmChange = this.onWmChange.bind(this);
        this.onSave = this.onSave.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.onShow = this.onShow.bind(this);
        this.setImageSize = this.setImageSize.bind(this);
        this.getPreviewHref = this.getPreviewHref.bind(this);
        this.onSaveTextDailog = this.onSaveTextDailog.bind(this);
        this.setScrolledHeight = this.setScrolledHeight.bind(this);
        this.setMulitLangPermission = this.setMulitLangPermission.bind(this);
        this.getPluginSettings = this.getPluginSettings.bind(this);
    }

    componentDidMount() {
        this.getPluginSettings();
    }

    render() {
        const {visible, loading, data, textVisible, textTemp, imgTemp, labelList, wmSetting, textEdited,clientTypeValue,optionList} = this.state;
        const {
            canEdit = false, enableMultiLang = false,
            oaaddress, licenseRemind, remindUserNames, remindDays, picturePath,
            filesystem, filesystembackup, filesystembackuptime, needzip, isaesencrypt, unsystem_help,
        } = data;
        const { isopen, mobileisopen, watermarktype, opacity, rotate, imageid } = wmSetting;
        const { wmwidth, wmheight, wmcontent } = textTemp;
        const disabled = !canEdit;
        const colProps = {labelCol: {span: 8}, wrapperCol: {span: 16}};
        return (
            <WeaDialog
                visible={visible}
                loading={loading}
                title={getLabel(774, '系统设置')}
                icon="wevicon-wea-system-setting"
                iconBgcolor='#a7adb5'
                style={{width: 700, height: 520}}
                zIndex={100}
                hasScroll={true}
                buttons={this.getButtons()}
                onCancel={this.onCancel}
            >
                <WeaSearchGroup title={getLabel(33174, '全局设置')} showGroup={true} center size="large">
                    <WeaFormItem label={getLabel(21870, 'OA访问地址')} {...colProps}>
                        <WeaInput value={oaaddress} disabled={disabled} onChange={value => this.onChange({oaaddress: value})}/>
                    </WeaFormItem>
                    {
                        canEdit ?
                            <WeaFormItem label={getLabel(33386, '授权信息到期提醒')} {...colProps}>
                                <WeaCheckbox display="switch" value={licenseRemind} onChange={value => this.onChange({licenseRemind: value})}/>
                            </WeaFormItem> : ''
                    }
                    {
                        canEdit && licenseRemind == '1' ?
                            <WeaFormItem label={getLabel(18013, '提醒对象')} {...colProps}>
                                <WeaBrowser
                                    type={17}
                                    title={getLabel(18013, '提醒对象')}
                                    isSingle={false}
                                    replaceDatas={remindUserNames}
                                    onChange={(ids, names, datas) => this.onChange({remindUsers: ids, remindUserNames: datas})}
                                />
                            </WeaFormItem> : ''
                    }
                    {
                        canEdit && licenseRemind == '1' ?
                            <WeaFormItem label={getLabel(32089, '提前提醒天数')} {...colProps}>
                                <WeaInput value={remindDays} onChange={value => this.onChange({remindDays: value})}/>
                            </WeaFormItem> : ''
                    }
                    {
                        canEdit ?
                            <WeaFormItem label={getLabel(507063, '禁用系统帮助')} {...colProps}>
                                <WeaCheckbox display="switch" value={unsystem_help} onChange={value => this.onChange({unsystem_help: value})}/>
                            </WeaFormItem> : ''
                    }
                </WeaSearchGroup>
                <WeaSearchGroup title={getLabel(33389, '文件存储设置')} showGroup={true} center size="large">
                    <WeaFormItem label={getLabel(20231, '图片存放目录')} {...colProps}>
                        <WeaInput
                            helpfulTip={canEdit ? getLabel(33390, '设置文件目录路径不能含有中文，不填写将默认存放在系统程序目录filesystem下') : ''}
                            value={picturePath}
                            disabled={disabled}
                            onChange={value => this.onChange({picturePath: value})}
                        />
                    </WeaFormItem>
                    <WeaFormItem label={getLabel(15046, '文件存放目录')} {...colProps}>
                        <WeaInput
                            helpfulTip={canEdit ? getLabel(33390, '设置文件目录路径不能含有中文，不填写将默认存放在系统程序目录filesystem下') : ''}
                            value={filesystem}
                            disabled={disabled}
                            onChange={value => this.onChange({filesystem: value})}
                        />

                    </WeaFormItem>
                    <WeaFormItem label={getLabel(15047, '文件备份目录')} {...colProps}>
                        <WeaInput
                            helpfulTip={canEdit ? getLabel(33390, '设置文件目录路径不能含有中文，不填写将默认存放在系统程序目录filesystem下') : ''}
                            value={filesystembackup}
                            disabled={disabled}
                            onChange={value => this.onChange({filesystembackup: value})}
                        />
                    </WeaFormItem>
                    <WeaFormItem label={getLabel(15048, '文件备份周期')} {...colProps}>
                        <WeaInput
                            helpfulTip={canEdit ? getLabel(25482, '设置为0或空表示不进行备份，默认备份周期是一小时（60分钟），大于0且小于等于60分钟则按照60分钟备份，大于60分钟即按照设置的时间进行备份') : ''}
                            value={filesystembackuptime}
                            disabled={disabled}
                            onChange={value => this.onChange({filesystembackuptime: value})}
                        />
                    </WeaFormItem>
                    <WeaFormItem label={getLabel(33391, '压缩存储')} {...colProps}>
                        <WeaCheckbox display="switch" value={needzip} disabled={disabled} onChange={value => this.onChange({needzip: value})}/>
                    </WeaFormItem>
                    <WeaFormItem label={getLabel(33392, '加密存储')} {...colProps}>
                        <WeaCheckbox display="switch" value={isaesencrypt} disabled={disabled} onChange={value => this.onChange({isaesencrypt: value})}/>
                    </WeaFormItem>
                </WeaSearchGroup>
                <WeaSearchGroup title={getLabel(504453, '系统默认水印')} showGroup={true} center size="large">
                    <WeaDialog
                        className="weatermark-text-dailog"
                        visible={textVisible}
                        title={getLabel(504454, '水印内容设置')}
                        icon="wevicon-wea-system-setting"
                        iconBgcolor='#a7adb5'
                        zIndex={200}
                        hasScroll={true}
                        style={{width: 600, height: 520}}
                        buttons={[<Button type="primary" onClick={this.onSaveTextDailog}>{getLabel(30986, '保存')}</Button>]}
                        onCancel={() => this.setState({ textVisible: false, textTemp: {
                            wmwidth: wmSetting.wmwidth,
                            wmheight: wmSetting.wmheight,
                            wmcontent: wmSetting.wmcontent
                        } })}
                    >
                        <WeaSearchGroup title={getLabel(504455, '水印大小设置')} showGroup={true} center size="large">
                            <WeaFormItem label={`${getLabel(504456, '水印宽度')}(px)`} {...colProps}>
                                <WeaInputNumber value={textTemp.wmwidth} min={100} step={10} onChange={value => this.setState({textTemp: {...textTemp, wmwidth: value}})} />
                            </WeaFormItem>
                            <WeaFormItem label={`${getLabel(504457, '水印高度')}(px)`} {...colProps}>
                                <WeaInputNumber value={textTemp.wmheight} min={100} step={10} onChange={value => this.setState({textTemp: {...textTemp, wmheight: value}})} />
                            </WeaFormItem>
                        </WeaSearchGroup>
                        <WeaSearchGroup title={getLabel(33368, '内容')} showGroup={true} center>
                            <div className="watermark-text-content">
                                <div className="watermark-text-content-left">
                                    <WeaRichText
                                        ref={ref => this.setScrolledHeight(ref)}
                                        ckConfig={basicToolBar}
                                        value={textTemp.wmcontent}
                                        onChange={(v) =>  this.setState({ textTemp: {...textTemp, wmcontent: v }})}
                                    />
                                </div>
                                <div className="watermark-text-content-right">
                                    <WeaFieldTemplateSelect
                                        scrolledHeight={this.scrolledHeight}
                                        options={labelList || []}
                                        searchValue={''}
                                        onClick={key => this.richText.insertHTML(key)}
                                    />
                                </div>
                            </div>
                        </WeaSearchGroup>
                    </WeaDialog>
                    <WeaFormItem label={getLabel(26472, '启用')} {...colProps}>
                        <WeaCheckbox
                            disabled={!canEdit} display="switch" value={isopen} onChange={value => this.onWmChange({isopen: value})}/>
                    </WeaFormItem>
                    {(canEdit && Number(isopen) === 1) &&
                    [
                        <WeaFormItem label={getLabel(504458, '移动端显示水印')} {...colProps}>
                            <WeaCheckbox display="switch" value={mobileisopen} onChange={value => this.onWmChange({mobileisopen: value})}/>
                        </WeaFormItem>
                    ]}
                    {canEdit &&
                    [
                        <WeaFormItem label={getLabel(504459, '网页水印类型')} {...{...colProps, wrapperCol: {span: 6}}}>
                            <WeaSelect
                                helpfulTip={canEdit ? getLabel(504460, '水印功能不支持IE10及以下版本的浏览器') : ''}
                                options={[
                                    { key: '1', selected: true, showname: getLabel(608, '文本') },
                                    { key: '2', selected: false, showname: getLabel(74, '图片') }
                                ]}
                                value={String(watermarktype)}
                                detailtype={3}
                                supportCancel={false}
                                onChange={v => {
                                    let fix = {};
                                    if (v == '1') {
                                        fix = {
                                            wmwidth: textTemp.wmwidth,
                                            wmheight: textTemp.wmheight,
                                        };
                                    }
                                    this.onWmChange({ watermarktype: Number(v), ...fix })
                                }}
                            />
                        </WeaFormItem>,
                        <WeaFormItem label={getLabel(504461, '网页水印内容')} {...colProps}>
                            { watermarktype === 2 ?
                                <div className="watermark-content">
                                    {(imageid && imageid > 0) ?
                                        <div className="watermark-content-image">
                                            <img onLoad={e => this.setImageSize(e.target)} width={50} src={`/weaver/weaver.file.FileDownload?fileid=${imageid}`} atl=""/>
                                            <span className="watermark-content-image-del">
                                                <Icon type="cross-circle" onClick={() => this.onWmChange({ imageid: '' })} />
                                            </span>
                                        </div> :
                                        <WeaUpload
                                            btnSize='small'
                                            maxFilesNumber={1}
                                            uploadUrl='/api/doc/upload/uploadFile'
                                            category='string'
                                            limitType='jpg,gif,png'
                                            clearWhenReset={false}
                                            showClearAll={false}
                                            onChange={ids => this.onWmChange({ imageid: ids[0] })}
                                        />
                                    }
                                    {(imageid && imageid > 0) ? this.getPreviewHref() : (Number(isopen) === 1 ? <span className="required upload" /> : null)}
                                </div> :
                                <div className="watermark-content">
                                    <Button className="watermark-content-setting" icon="setting" onClick={() => this.setState({ textVisible: true })} />
                                    {textEdited ? <Icon type="check" className="success" /> : (Number(isopen) === 1 ? <span className="required" /> : null)}
                                    {wmcontent && this.getPreviewHref()}
                                </div>
                            }

                        </WeaFormItem>,
                        <WeaFormItem label={getLabel(504462, '不透明（百分比）')} {...colProps}>
                            <WeaInputNumber value={opacity} max={100} min={0} onChange={value => this.onWmChange({ opacity: value })} />
                        </WeaFormItem>,
                        <WeaFormItem label={getLabel(504463, '旋转角度（逆时针）')} {...colProps}>
                            <WeaInputNumber value={rotate} max={360} min={0} onChange={value => this.onWmChange({ rotate: value })} />
                        </WeaFormItem>,
                        <WeaFormItem label={getLabel(504464, '附件水印设置')} {...colProps} >
                            <Button
                                className="watermark-attachment-setting"
                                icon="setting"
                                onClick={() => window.open("/wui/engine.html#/docengine/sec/applysetting?watermark=2", "_blank")}
                            />
                            {canEdit ? <WeaHelpfulTip style={{ verticalAlign: 'middle' }} title={getLabel(504465, '附件文件中显示的水印与网页水印不同，需单独设置')} /> : ''}
                        </WeaFormItem>
                    ]}
                </WeaSearchGroup>
                <WeaSearchGroup title={
                    <span>
                        <span style={{marginRight:'10px'}}>{getLabel(507449, '国产操作系统环境下的插件设置')}</span>
                        <WeaHelpfulTip
                            title={getLabel(507455,'非国产操作系统，此设置无效')}
                            placement="top"
                        />
                        </span>
                } showGroup={true} center size="large">
                    <WeaFormItem
                        label={getLabel(501599, '插件类型')}
                        {...colProps}
                    >
                        <WeaSelect
                            options={optionList}
                            value={clientTypeValue}
                            viewAttr={canEdit?2:1}
                            onChange={(v)=> {
                                this.setState({clientTypeValue : v});
                            }}
                        />
                    </WeaFormItem>
                </WeaSearchGroup>
            </WeaDialog>
        );
    }

    getButtons() {
        const {data} = this.state;
        let buttons = [];
        if (data.canEdit) {
            buttons.push(<Button type="primary" onClick={this.onSave}>{getLabel(30986, '保存')}</Button>);
        }
        return buttons;
    }

    setScrolledHeight(ref) {
        // 计算变量关键字列表高度，使其与富文本等高
        this.richText = ref;
        if (!ref || this.scrolledHeight > 0) return;
        let height = 0;
        if (ref && ref.refs.wrap) {
            const top = 37 + 4;
            height = ref.refs.wrap.clientHeight - top;
        }
        this.scrolledHeight = height;
    }

    setImageSize(img) {
        // 获取图片的原始尺寸
        if (img) {
            let fix = {
                wmwidth: img.naturalWidth > 200 ? img.naturalWidth : 200,
                wmheight: img.naturalHeight > 150 ? img.naturalHeight : 150,
            };
            this.setState({ imgTemp: fix });
            this.onWmChange(fix);
        }
    }

    getPreviewHref() {
        const { wmSetting } = this.state;
        let href = "/cloudstore/resource/pc/watermark/preview.html";
        let params = '?';
        Object.keys(wmSetting || {}).forEach(key => {
            params += `${key}=${encodeURIComponent(wmSetting[key])}&`;
        });
        href += params;
        return (<a style={{ paddingLeft: 15 }} href={href} target="_blank">{getLabel(221, '预览')}</a>);
    }

    onSaveTextDailog() {
        const { textTemp } = this.state;
        console.log(textTemp);
        if (textTemp.wmcontent) {
            this.onWmChange(textTemp);
            this.setState({ textVisible: false, textEdited: true });
        } else {
            Modal.error({
                content: getLabel(504467, '请输入文本水印内容'),
            });
        }
    }

    onWmChange(obj) {
        const { wmSetting } = this.state;
        this.setState({ wmSetting: { ...wmSetting, ...obj }});
    }

    onChange(obj) {
        const {data} = this.state;
        this.setState({data: {...data, ...obj}});
    }

    onSave() {
        const {onSave} = this.props;
        const {data, wmSetting,clientTypeValue} = this.state;
        if ((wmSetting.isopen === 1 || wmSetting.isopen === '1') && (
            (!wmSetting.watermarktype) ||
            (wmSetting.watermarktype === 1 && !wmSetting.wmcontent) ||
            (wmSetting.watermarktype === 2 && (!wmSetting.imageid || wmSetting.imageid <= 0)))) {
            // 水印必填处理
            Modal.error({
                content: wmSetting.watermarktype === 2 ? getLabel(504466, '请选择水印图片') : getLabel(504467, '请输入文本水印内容'),
            });
            return ;
        }
        this.setState({visible: true, loading: true});
        let done = 0;
        let cb = (res) => {
            done += 1;
            if (done === 2) {
                // 修改水印
                WeaTools.watermark.getSystemSetting();
                this.onCancel();
                if (onSave && typeof onSave == 'function') onSave();
            }
        }
        WeaTools.callApi('/api/portal/systemInfo/saveSettingData', 'POST', { ...data }).then(() => {
            WeaTools.callApi('/api/systeminfo/othersetting/getHelp', 'GET', {}).then(result => {
                WeaTools.ls.set('showHelp', { showHelp: result.helpmenu });
            });
        }).then(cb);
        WeaTools.callApi('/api/doc/console/wmsystemsetting/savewmsetting', 'POST', { ...wmSetting }).then(cb);
        WeaTools.callApi('/api/odoc/odocPluginSettings/savePluginSettings', 'POST', { clientType: clientTypeValue }).then(cb);
    }

    onCancel() {
        this.setState({visible: false, loading: false});
    }

    onShow() {
        this.setState({visible: true, loading: true});
        WeaTools.callApi('/api/portal/systemInfo/getSettingData', 'GET', {}).then(result => {
            const {data} = result;
            this.setState({ loading: false, data });
        });
        // 获取水印设置
        WeaTools.callApi('/api/doc/console/wmsystemsetting/getwmsetting', 'GET', {}).then(result => {
            const { wmSetting } = result;
            console.log(wmSetting);
            if (wmSetting) {
                const { wmwidth, wmheight, wmcontent } = wmSetting;
                this.setState({ wmSetting,
                    imgTemp: { wmwidth, wmheight },
                    textTemp: { wmwidth, wmheight, wmcontent },
                    textEdited: !!wmcontent });
            }
        });
        // 获取文本水印变量
        WeaTools.callApi('/api/doc/console/wmsystemsetting/getwmtextparam', 'GET', {}).then(result => {
            const { labelList } = result;
            this.setState({ labelList });
        });
    }

    setMulitLangPermission() {
        const dialog = new window.Dialog();
        dialog.currentWindow = window;
        dialog.Height = 650;
        dialog.Width = 600;
        dialog.Title = getLabel(34032, '多语言')+getLabel(18599, '授权')+getLabel(68, '设置');
        dialog.URL = '/docs/tabs/DocCommonTab.jsp?_fromURL=80&isdialog=1';
        dialog.show();
    }

    getPluginSettings(){
        // 获取插件列表
        WeaTools.callApi('/api/odoc/odocPluginSettings/getPluginSettings', 'POST', {}).then(result => {
            const {pluginSetting} = result;
            if (pluginSetting) {
                const {clientTypeValue, optionList} = pluginSetting;
                this.setState({
                    clientTypeValue: clientTypeValue,
                    optionList: optionList
                });
            }
        });
    }
}

export default WeaSystemSetting;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4public/wea-system-setting/index.js